<div class="bannedPlayer">
  <div class="iconWrap">
    <i class="icon-password" *ngIf="!isIdentVerifyFailed"></i>
    <i class="icon-info" *ngIf="isIdentVerifyFailed"></i>
  </div>
  <p class="infoDesc">
    {{ displayMessage | transloco }}
  </p>
  <button class="dsButton dsButton-primary" (click)="refreshPlayer()">
    <i class="dsButton_prefix icon-refresh"></i>
    {{ 'MODULES.COMMON.REFRESH' | transloco }}
  </button>
</div>
